import { render, staticRenderFns } from "./WordpressPluginForm.vue?vue&type=template&id=0c093768&"
import script from "./WordpressPluginForm.vue?vue&type=script&lang=ts&"
export * from "./WordpressPluginForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports